import React from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ViewFigure from "./images/viewfigure.png";

const BusinessQuestionsSection = () => {
  return (
    <Box
      sx={{
        background: {
          xs: `url(${ViewFigure}) right bottom no-repeat`,
          md: `url(${ViewFigure}) right bottom no-repeat`,
        },
        backgroundSize: { xs: "95%", md: "30%" },
        backgroundPosition: { xs: "right 0px 100px", md: "right" },

        color: "#000",
        py: { xs: 6, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        position: "relative",
        minHeight: { xs: "auto", md: "80vh" },
      }}
    >
      <Box sx={{ maxWidth: "900px", mx: "auto", mb: 6 }}>
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            backgroundColor: "white",
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Вы чувствуете, что ваш бизнес может приносить больше?
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: {
            xs: "rgba(255, 255, 255, 0.7)",
            md: "transparent",
          },
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            backgroundColor: {
              xs: "rgba(255, 255, 255, 0.9)",
              md: "transparent",
            },
            p: { xs: 2, md: 0 },
            borderRadius: { xs: "10px", md: "0" },
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              background:
                "linear-gradient(to right, #7e5f89, #c77792, #cc7472)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontSize: {
                xs: "1.25rem",
                md: "1.5rem",
              },
            }}
          >
            У вас всё чаще появляются вопросы:
          </Typography>
          <List>
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon sx={{ color: "#7e5f89" }} />
              </ListItemIcon>
              <ListItemText primary="Как найти скрытые возможности для роста?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon sx={{ color: "#7e5f89" }} />
              </ListItemIcon>
              <ListItemText primary="Как наладить процессы и освободить время для главного?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon sx={{ color: "#7e5f89" }} />
              </ListItemIcon>
              <ListItemText primary="Как достичь гармонии между управлением бизнесом и личной жизнью?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon sx={{ color: "#7e5f89" }} />
              </ListItemIcon>
              <ListItemText primary="Как увеличить средний чек и удержать клиентов?" />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <HelpOutlineIcon sx={{ color: "#7e5f89" }} />
              </ListItemIcon>
              <ListItemText primary="Как усилить команду и повысить её эффективность?" />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BusinessQuestionsSection;
